import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import {
  ErrorDetails,
  TransportTypeRequestDTO
} from "app/services/authentication/connection/interfaces/apiInterfaces";

export class GetVehicleTypeByIdCommand extends IRequestCommand<
  IGetVehicleTypeByIdResponse,
  ErrorDetails,
  IGetVehicleTypeByIdCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'transportTypes/{transportTypesId}';
  public override setParameters(parameters: IGetVehicleTypeByIdCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{transportTypesId}',
      parameters.transportTypesId.toString()
    );
  }
}

export interface IGetVehicleTypeByIdCommandParameters
  extends ICommandParameters {
  transportTypesId?: number;
}

export interface IGetVehicleTypeByIdResponse
  extends TransportTypeRequestDTO,
    ICommandResponse {}
